import { render, staticRenderFns } from "./TrendingCreators.vue?vue&type=template&id=0d28e850&"
import script from "./TrendingCreators.vue?vue&type=script&lang=js&"
export * from "./TrendingCreators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports